module.exports = __webpack_public_path__ + "img/lb_menu_bg_d_l.9722aa7c.png";